import { Show } from '../models/show';

// Bandsintown leaves `title` blank for most shows, so fall back to the venue name.
export function showTitle(show: Pick<Show, 'title' | 'venue'>): string {
  return show.title?.trim() || show.venue?.name?.trim() || '';
}
